import { colors } from '../../colors';
var button = {
  //Hero button
  linkColorHero: colors.white,
  linkColorHeroHover: colors.white,
  backgroundColorHero: colors.neonPurple,
  backgroundColorHoverHero: colors.amethyst,
  borderRadiusHero: '3px',
  linkLineHeightHero: '30px',
  heroButtonPadding: '20px 35px',
  //primary button
  linkColorPrimary: colors.white,
  linkColorPrimaryHover: colors.white,
  backgroundColorPrimary: colors.neonPurple,
  backgroundColorHoverPrimary: colors.amethyst,
  borderRadiusPrimary: '3px',
  //secondary button
  linkColorSecondary: colors.white,
  linkColorSecondaryHover: colors.white,
  backgroundColorSecondary: colors.neonPurple,
  backgroundColorHoverSecondary: colors.amethyst,
  borderRadiusSecondary: '3px',
  borderColorSecondary: 'transparent',
  borderColorSecondaryHover: 'transparent'
};
export default button;